/*
 * rootEpic.js
 * trt_cms2
 *
 * Created by Hisyam on 27/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  addPostEpic,
  deletePostEpic,
  fetchPostEpic,
  fetchPostsEpic,
  newPostEpic,
  resetRedirectPostEpic,
  updatePostEpic
} from "./blogs/blogsAction";
import {combineEpics} from "redux-observable";
import {catchError} from "rxjs/operators";
import {loadUserEpic, loginEpic, logoutEpic} from "./auth/authAction";
import {
  addCareerEpic,
  deleteCareerEpic,
  fetchCareerEpic,
  fetchCareersEpic,
  newCareerEpic,
  resetRedirectCareerEpic,
  updateCareerEpic
} from "./careers/careersAction";
import {imagesEpic} from "./images/imagesAction";
import {pagesEpic} from "./pages/pagesAction";
import {clientsEpic} from "./clients/clientsAction";
import {testimonialsEpic} from "./testimonials/testimonialsAction";
import {worksEpic} from "./works/worksAction";
import {servicesEpic} from "./services/servicesAction";
import {companiesEpic} from "./companies/companiesAction";
import {employeesEpic} from "./employee/employeeAction";
import {achievementsEpic} from "./achievements/achievementsAction";
import {sectionsEpic} from "./sections/sectionsAction";

// const rootEpic = combineEpics(
//   fetchPostsEpic
// );

const epics = [
  loadUserEpic,
  loginEpic,
  logoutEpic,
  fetchCareersEpic,
  fetchCareerEpic,
  newCareerEpic,
  addCareerEpic,
  updateCareerEpic,
  deleteCareerEpic,
  resetRedirectCareerEpic,
  fetchPostsEpic,
  fetchPostEpic,
  newPostEpic,
  addPostEpic,
  updatePostEpic,
  deletePostEpic,
  resetRedirectPostEpic,
  ...imagesEpic,
  ...pagesEpic,
  ...clientsEpic,
  ...testimonialsEpic,
  ...worksEpic,
  ...servicesEpic,
  ...companiesEpic,
  ...employeesEpic,
  ...achievementsEpic,
  ...sectionsEpic,
];
const rootEpic = (action$, store$, dependencies) =>
  combineEpics(...epics)(action$, store$, dependencies).pipe(
    catchError((error, source) => {
      console.error(error);
      return source;
    })
  );

export default rootEpic;